import {
  Button,
  CircularProgress,
  Link,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import StaffApi from "api/StaffApi";
import { useHistory, useLocation } from "react-router-dom";
import { Alert, AlertTitle } from "@material-ui/lab";
const Container = styled.div`
  width: 40%;
  margin: 50px auto;

  > * {
    margin-bottom: ${({ theme: { spacing } }) => spacing(2)}px;
  }
`;

const ResetPassword = () => {
  const { t } = useTranslation("login");
  const history = useHistory();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const queryString = new URLSearchParams(useLocation().search);
  const resetToken = queryString.get("token");
  const [staffId, setStaffId] = useState<number>();
  const [isSent, setIsSent] = useState(false);

  const onChangePassword = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setPassword(event.target.value);
  };

  const onClickPostButton = async () => {
    if (!password || !staffId) return;

    setLoading(true);
    await StaffApi.resetPassword(staffId, password);
    setLoading(false);
    setIsSent(true);
  };
  useEffect(() => {
    const getStaff = async () => {
      try {
        const result = await StaffApi.findByResetToken(resetToken || "");
        setStaffId((result as any).staffId);
      } catch {
        history.push("/resetPassword/send");
      }
    };
    getStaff();
  }, []);

  return (
    <Container>
      <Typography>{t("resetPassword.prompt")}</Typography>
      <TextField
        label={t("password")}
        required
        type="password"
        autoComplete="current-password"
        variant="filled"
        fullWidth
        onChange={onChangePassword}
      />
      <Button
        variant="contained"
        color="primary"
        fullWidth
        disabled={loading || isSent}
        onClick={onClickPostButton}
      >
        {loading ? <CircularProgress color="inherit" size={24} /> : t("resetPassword.submit")}
      </Button>
      {isSent && (
        <Alert severity="success">
          <AlertTitle>{t("resetPassword.successTitle")}</AlertTitle>
          <Link href="/login">{t("resetPassword.loginLink")}</Link>
          {t("resetPassword.loginSuffix")}
        </Alert>
      )}
    </Container>
  );
};
export default ResetPassword;
